import * as React from "react";
const Tick = ({
  className = "",
  height = 800,
  width = 800,
  color = "#000",
  props,
}) => (
  <div className={className}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2.5}
        d="m4.892 13.269 4.274 4.274L18.709 8"
      />
    </svg>
  </div>
);
export default Tick;
